import React, { Fragment } from 'react';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import FooterS2 from '../../components/footerS2/FooterS2';
import Logo from '../../images/logo.png'
import bg from '../../images/gallery/SSK_0136.png';

const ContactPage = () => {
    return (
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} bg={bg}/>
            <Contactpage />
            <FooterS2 />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

